<div *ngIf="listaCuentas && listaCuentas.length > 0" class="flex flex-col gap-4 p-4">
    <div *ngFor="let cuenta of listaCuentas">
      <app-withdraw-account-card [cuenta]="cuenta" (deleteAccount)="eliminarCuenta()" (actualizarCuenta)="actualizar($event)"></app-withdraw-account-card>
    </div>
  </div>